"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _uiLibrary = require("@sm360/ui-library");

var _lodash = require("lodash");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactI18nify = require("react-i18nify");

var _SectionStatus = _interopRequireDefault(require("../../constants/SectionStatus.js"));

var LocaleService = {
  t: _reactI18nify.translate
};

var Section = function Section(_ref) {
  var name = _ref.name,
      title = _ref.title,
      number = _ref.number,
      collapsable = _ref.collapsable,
      isOpen = _ref.isOpen,
      setIsOpen = _ref.setIsOpen,
      noHeader = _ref.noHeader,
      status = _ref.status,
      onNext = _ref.onNext,
      children = _ref.children;

  var getStatusIcon = function getStatusIcon(currentStatus) {
    switch (currentStatus) {
      case _SectionStatus.default.NOT_STARTED:
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "status-icon"
        });

      case _SectionStatus.default.STARTED:
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "status-icon"
        }, "!");

      case _SectionStatus.default.COMPLETED:
        return /*#__PURE__*/_react.default.createElement(_uiLibrary.Icon, {
          name: "checkmark",
          color: "white",
          className: "status-icon"
        });

      default:
        return undefined;
    }
  };

  var header = /*#__PURE__*/_react.default.createElement("div", {
    className: "question-section__title"
  }, /*#__PURE__*/_react.default.createElement("span", null, title), collapsable && /*#__PURE__*/_react.default.createElement("div", {
    className: "question-section__title-icons ".concat(status.toLowerCase())
  }, getStatusIcon(status), /*#__PURE__*/_react.default.createElement(_uiLibrary.Icon, {
    name: "chevron-thin-down",
    className: isOpen ? 'inverted' : ''
  })));

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(collapsable ? 'collapsable' : '')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "question-section",
    id: "question-section-".concat(name),
    key: "row-".concat(number)
  }, collapsable ? /*#__PURE__*/_react.default.createElement(_uiLibrary.Expander, {
    trigger: header,
    isOpen: isOpen,
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    },
    iconPosition: "hide"
  }, children, /*#__PURE__*/_react.default.createElement("div", {
    className: "question-section-buttons"
  }, /*#__PURE__*/_react.default.createElement(_uiLibrary.Button, {
    label: LocaleService.t('OFFICIAL_EVALUATION.BUTTONS.NEXT'),
    color: "primary",
    onClick: function onClick() {
      return onNext(name);
    },
    className: "question-section-buttons--next"
  }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !noHeader && header, children)));
};

Section.defaultProps = {
  collapsable: false,
  noHeader: false,
  completed: false,
  onNext: _lodash.noop
};
Section.propTypes = {
  /**
   * Name (key) of section
   */
  name: _propTypes.default.string.isRequired,

  /**
   * Title of section
   */
  title: _propTypes.default.string,

  /**
   * Number of section
   */
  number: _propTypes.default.number.isRequired,

  /**
   * Allow section to be collapsable
   */
  collapsable: _propTypes.default.bool,

  /**
   * Define if the section is opened or closed
   */
  isOpen: _propTypes.default.bool.isRequired,

  /**
   * Callback function setIsOpen
   * Invoked when clicking on a section
   */
  setIsOpen: _propTypes.default.func.isRequired,

  /**
   * Hide header
   */
  noHeader: _propTypes.default.bool,

  /**
   * Define current status of the section
   */
  status: _propTypes.default.oneOf([_SectionStatus.default.NOT_STARTED, _SectionStatus.default.STARTED, _SectionStatus.default.COMPLETED]),

  /**
   * Callback onNext
   * Invoked when clicking on 'Next button'
   */
  onNext: _propTypes.default.func,

  /**
   * Content of section
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.arrayOf(_propTypes.default.element)]).isRequired
};
var _default = Section;
exports.default = _default;